/* theme/assets/fm-bundle-state.js — Formula buy-box state (spec 2026-10-02 §5.1). Pure — no DOM.
   Cards are quantity bundles of one variant, or (Ritmovio spec 2026-10-04 §5.2) format cards that each select a variant.
   Browser: window.FmBundleState; tests: globalThis.FmBundleState. Needs FmMoney. */
(function (root) {
  const fmtWith = (format) => (cents) => root.FmMoney.format(cents, format);
  const percent = (price, ref) => (ref > price && ref > 0 ? Math.round((1 - price / ref) * 100) : 0);
  const EMPTY = { variant: null, available: false, cards: [], card: null, subscribe: false, canSubscribe: false, planId: null, subscribePercent: 0, price: 0, compare: 0, priceText: '', compareText: '', percent: 0, items: [], shipping: false, tracked: false };

  function compute(o) {
    const variants = o.variants || [];
    const fmt = fmtWith(o.moneyFormat);
    const state = o.state || {};
    const byFormat = (name) => (name ? variants.find((v) => v.option1 === name || v.title === name) || null : null);
    // A format card the product has no variant for is dropped: selling another variant under its label would charge for the wrong item.
    const raw = (o.cards || []).filter((c) => !c.variant || byFormat(c.variant));
    const opened = variants.find((v) => String(v.id) === String(o.variantId)) || variants.find((v) => v.available) || variants[0] || null;
    const chosenRaw = raw.find((c) => c.id === state.card) || raw.find((c) => c.id === o.defaultCard) || raw[0] || null;
    const variant = byFormat(chosenRaw && chosenRaw.variant) || opened;
    if (!variant) return { ...EMPTY };
    const plans = variant.selling_plan_allocations || [];
    const canSubscribe = !!o.subscriptionEnabled && plans.length > 0;
    const subscribe = canSubscribe && state.subscribe === true;
    const plan = subscribe ? plans.find((a) => String(a.selling_plan_id) === String(state.planId)) || plans[0] : null;
    const unit = plan ? plan.price : variant.price;
    const ref = Math.max(variant.compare_at_price || 0, variant.price);
    const cards = raw.map((c) => {
      if (c.variant) {
        const cv = byFormat(c.variant) || opened;
        const price = cv === variant ? unit : cv.price;
        const compare = Math.max(cv.compare_at_price || 0, cv.price);
        return { id: c.id, paid: 1, free: 0, units: 1, title: c.title || '', price, compare, priceText: fmt(price), compareText: compare > price ? fmt(compare) : '', perUnitText: '', percent: percent(price, compare), selected: false };
      }
      const paid = Math.max(1, Number(c.paid) || 1);
      const free = Math.max(0, Number(c.free) || 0);
      const units = paid + free;
      const price = paid * unit;
      const compare = units * ref;
      return { id: c.id, paid, free, units, title: c.title || '', price, compare, priceText: fmt(price), compareText: compare > price ? fmt(compare) : '', perUnitText: units > 1 ? fmt(Math.round(price / units)) : '', percent: percent(price, compare), selected: false };
    });
    const chosen = (chosenRaw && cards.find((c) => c.id === chosenRaw.id)) || null;
    cards.forEach((c) => { c.selected = c === chosen; });
    const pick = chosen || { id: null, paid: 1, free: 0, title: '', price: unit, compare: ref };
    const available = !!variant.available;
    const items = available ? [
      { id: variant.id, quantity: pick.paid, ...(plan ? { selling_plan: plan.selling_plan_id } : {}) },
      ...(pick.free > 0 ? [{ id: variant.id, quantity: pick.free, properties: { _fm_bundle: pick.title } }] : []),
    ] : [];
    return {
      variant, available, cards, card: pick.id, subscribe, canSubscribe, planId: plan ? plan.selling_plan_id : null,
      subscribePercent: plans[0] ? percent(plans[0].price, variant.price) : 0,
      price: pick.price, compare: pick.compare, priceText: fmt(pick.price), compareText: pick.compare > pick.price ? fmt(pick.compare) : '', percent: percent(pick.price, pick.compare),
      items, shipping: variant.requires_shipping !== false, tracked: variant.inventory_management === 'shopify',
    };
  }
  /** "<variantId>:<sold %> …" (written by the stock block) → that variant's sold percent, or null when it is not tracked. */
  function stockPercent(attr, variantId) {
    for (const pair of String(attr || '').split(' ')) {
      const [id, pct] = pair.split(':');
      if (id && id === String(variantId)) return Number(pct);
    }
    return null;
  }
  root.FmBundleState = { compute, stockPercent };
})(typeof window !== 'undefined' ? window : globalThis);
